module.exports = __webpack_public_path__ + "img/business1_E.0b7e0bad.png";